import {ICmsApi} from '../../api/cms-api.service';
import {CmsEditorDialog} from './cms-editor-dialog.controller';
import {ILoginService} from '../../auth/login.service';

export interface ICmsContent {
	text: string, 
	language: string,
	type: string
}

const cmsEditorDialogTemplate = require<string>(
    './cms-editor-dialog.html');

export default class CmsController {
	static $inject = ['cmsApi', '$translate', '$mdDialog', '$rootScope', 'loginService']

	private contentName: string;
	private cmsContent: ICmsContent[];
	private cmsContentText: string;
	private languageId: string;
	private loggedIn:boolean;

	constructor (
		private cmsApi: ICmsApi,
		private $translate:ng.translate.ITranslateService,
		private $mdDialog: ng.material.IDialogService,
		private $rootScope: ng.IRootScopeService,
		private loginService: ILoginService,
	) {
		this.languageId = this.$translate.proposedLanguage();


		this.loggedIn = loginService.isLoggedIn();

		this.fetchContent();

	  	this.$rootScope.$on('$translateChangeStart',
	    	($event: ng.IAngularEvent, args: {language: string}) => { 
	      		this.cmsContentText = this.getCmsContent(args.language);
	      	})

	  	loginService.onLoginStateChange((loggedIn) => {
	  	  this.loggedIn = loginService.isLoggedIn();
	  	  if (this.loggedIn) {
	  	  	this.fetchContent();	
	  	  }
	  	});
	}

	fetchContent() {
		this.cmsApi.getCmsContent(this.contentName)
		  .then((content) => {
		  	if (content && content.length) {
		  		this.cmsContent = content;
		  	} else {
		  		this.cmsContent = [
					{
						text: '',
						type: this.contentName,
						language: 'en'
					},
					{
						text: '',
						type: this.contentName,
						language: 'ru'
					}
				]
		  	}
		    
		    this.cmsContentText = this.getCmsContent(this.languageId);
		    
		  })
	}

	getCmsContent(language: string) {
		let cmsContent: ICmsContent;

		_.forEach(this.cmsContent, (content) => {
			if (content.language == language) {
				cmsContent = content
			};
		});

		return cmsContent.text;
	}

	onEditClick($event: MouseEvent) {
		this.$mdDialog.show({
		  targetEvent: $event,
		  template: cmsEditorDialogTemplate,
		  controller: CmsEditorDialog,
		  bindToController: true,
		  controllerAs: '$ctrl',
		  locals: {
		  	cmsContent: this.cmsContent
		  }
		})
		.then((cmsContent: ICmsContent[]) => {
			this.cmsApi.saveCmsContent(this.contentName, cmsContent)
			  .then(() => {
			  	this.cmsContent = cmsContent;
			  	this.cmsContentText = this.getCmsContent(this.languageId);
			  })
		});
	}
}


/** WEBPACK FOOTER **
 ** ./app/hydromet/cms/cms.controller.ts
 **/